export enum ErrorCodes {
  UserNotFound = "auth/user-not-found",
  InvalidEmail = "auth/invalid-email",
  MissingPassword = "auth/missing-password",
}
